import { handleActions } from 'redux-actions';
import { setError, setLoading } from './actions';

const defaultState = {
  error: null,
  isLoading: false,
};

function reduceSetLoading(state, action) {
  const isLoading = action.payload;
  return {
    ...state,
    isLoading,
  };
}

function reduceSetError(state, action) {
  const error = action.payload;
  return {
    ...state,
    error,
  };
}

const reducer = handleActions(
  {
    [setError]: reduceSetError,
    [setLoading]: reduceSetLoading,
  },
  defaultState,
);

export default reducer;



// WEBPACK FOOTER //
// ./src/store/app/reducer.js